// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"header_wrapper__Ys_hw","bg":"header_bg__3F_8L","print":"header_print__1sWte","logo":"header_logo__2pOV0"};